import { gql } from '@grandvisionhq/graphql';
import { estimatedDelivery } from '../fragments/estimated-delivery.js';

const GET_ESTIMATED_DELIVERY_BY_SKUS = gql`
  query GetEstimatedDeliveryBySkus($input: EstimatedDeliveryBySkuInput!) {
    estimatedDeliveryBySkus(input: $input) {
      ...EstimatedDeliveryFragment
    }
  }
  ${estimatedDelivery}
`;

export { GET_ESTIMATED_DELIVERY_BY_SKUS };
//# sourceMappingURL=get-estimated-delivery-by-skus.js.map
